import { Instance, types } from 'mobx-state-tree'

export const VehicleModuleVersionModel = types.model('VehicleModuleVersionModel')
.props({
    module: types.string,
    display_name: types.string,
    last_update_timestamp: types.maybeNull(types.string),
    version: types.maybeNull(types.string),
})
.views((self) => ({
    get displayName() {
        return self.display_name
    },
    get displayVersion() {
        return self.version ?? '--'
    }
}))
.views((self) => ({
    get copyText() {
        return `${self.displayName}: ${self.displayVersion}`
    }
}))


export type VehicleModuleVersion = Instance<typeof VehicleModuleVersionModel>
